import CCP_NEW_URLS from "../constants/CcpUrls";
import EndPointInfo from "./Endpoints";
import _, { result } from "lodash";

export const URL = {
  METHOD: {
    START_CONTACT: "startContact",
    CREATE_PARTICIPANT_TOKEN: "createParticipantToken",
    SEND_MESSAGE: "sendMessage",
    TRANSCRIPT_DETAILS: "getTranscriptDetails",
    STORE_PRE_CHAT_DETAILS: "storePreChatDetails",
    DISCONNECT_PARTICIPANT: "disconnectParticipant",
    STORE_POST_CHAT_FEEDBACK_DETAILS: "storePostChatFeedbackDetails",
    VALIDATE_TOKEN_NUMBER: "validateTokenNumber",
    TEST_METHOD: "",
    STORE_TRANSCRIPT_DETAILS: "storeTranscriptDetails",
    CHAT_EVENT: "chatEvent",
    GET_TRANSCRIPT: "getTranscript",
    STORE_CANNED_MSG_DETAILS: "storeCannnedMsgDetails",
    STORE_QUEUE_DETAILS: "storeQueueDetails",
  },
  PARAMS: {
    START_CONTACT: {
      method: "",
      name: "",
      contactFlowId: "",
      site: "",
    },
    CREATE_PARTICIPANT_TOKEN: {
      method: "",
      participantToken: "",
      connectionType: "",
      contactId: "",
    },
    SEND_MESSAGE: {
      method: "",
      ConnectionToken: "",
      Content: "",
      contactId: "",
    },
    TRANSCRIPT_DETAILS: {
      method: "",
      ConnectionToken: "",
      contactId: "",
    },
    STORE_PRE_CHAT_DETAILS: {
      method: "",
      data: {
        contactID: "",
        initialContactId: "",
        phoneNumber: "",
        demography: {
          fName: "",
          lName: "",
          email: "",
          address: "",
        },
        userDevice: null,
      },
    },
    DISCONNECT_PARTICIPANT: {
      method: "",
      ConnectionToken: "",
      InitialContactId: "",
    },
    CHAT_FEEDBACK_SUBMIT: {
      method: "storePostChatFeedbackDetails",
      data: {
        rating: "",
        reasons: [],
        comment: "",
        InitialContactId: "",
        contactIdList: [],
      },
    },
    STORE_USER_WEB_JOURNEY: {
      method: "storeUserWebJourney",
      data: {
        InitialContactId: "",
        userWebDetails: {},
      },
    },
    STORE_TRANSCRIPT_DETAILS: {
      method: "storeTranscriptDetails",
      InitialContactId: "",
      Transcript: [],
    },
    CHAT_EVENT: {
      method: "",
      chatId: "",
      site: "",
    },
    VALIDATE_TOKEN_NUMBER: {
      method: "",
      data: {
        contactId: "",
        token: "",
      },
    },
    GET_TRANSCRIPT: {
      method: "getTranscript",
      InitialContactId: "",
    },
    GET_CANNED_MESSAGES: {
      method: "getCannedMsgList",
      site: "",
    },
    GET_ASSIST: {
      query: "",
      initialContactId: "",
      is_manual: false,
    },
    STORE_CANNED_MSG_DETAILS: {
      method: "storeCannedMsgAttributes",
      data: {
        contactId: "",
        queueName: "",
        message: "",
        messageTimeStamp: "",
        agentUserName: "",
        messageDate: "",
      },
    },
    STORE_QUEUE_DETAILS: {
      method: "storeQueueDetails",
      data: {
        InitialContactID: "",
        queueDetails: [],
      },
    },
    GET_GIFT_CARD: {
      method: "getGiftCard",
      data: {
        contactId: "",
        initialContactId: "",
      },
    },
    USER_DETAILS: {
      method: "getUserDetails",
      data: {
        InitialContactId: "",
      },
    },
  },
};

export const EVENT_TYPES = {
  OFFER: "offer",
  ACCEPT: "accept",
  CLOSE: "close",
  REJECT: "reject",
  USER_START: "userStart",
  INITIATE: "initiate",
};

export const EVENT_CONTENT_TYPE = {
  TYPING: "application/vnd.amazonaws.connect.event.typing",
  PARTICIPANT_JOINED:
    "application/vnd.amazonaws.connect.event.participant.joined",
  PARTICIPANT_LEFT: "application/vnd.amazonaws.connect.event.participant.left",
  TRANSFER_SUCCEEDED:
    "application/vnd.amazonaws.connect.event.transfer.succeeded",
  TRANSFER_FAILED: "application/vnd.amazonaws.connect.event.transfer.failed",
  CONNECTION_ACKNOWLEDGED:
    "application/vnd.amazonaws.connect.event.connection.acknowledged",
  CHAT_ENDED: "application/vnd.amazonaws.connect.event.chat.ended",
  INITIATED: "initiated",
};
export const SITE_MAP_ENUM = [
  {
    site: "HI",
    value: ["NONMSO_HI_CH_ENG_SALES", "MSO_HI_CH_ENG_SALES"],
    ignore: false,
  },
  {
    site: "HS",
    value: "MSO_RP_CH_ENG_CARE",
    ignore: false,
  },
  {
    site: "HS_SALES",
    value: "MSO_RP_CH_ENG_SALES",
    ignore: false,
  },
  {
    site: "HS_TECHSPEC",
    value: "MSO_RP_CH_ENG_COVERED",
    ignore: false,
  },
  {
    site: "OBU",
    value: [
      "MSO_DL_CH_ENG_CARE",
      "MSO_OBU_CH_ENG_SALES",
      "MSO_OBU_CH_ENG_CARE",
    ],
    ignore: false,
  },
  {
    site: "PD",
    value: ["MSO_PD_CH_ENG_SALES", "MSO_PD_CH_ENG_CARE"],
    ignore: false,
  },
];

export const isJson = (str) => {
  try {
    JSON.parse(str);
  } catch (error) {
    return false;
  }

  return true;
};

export const buildEndPointsForCCP = (request) => {
  if ("enableNewURL" in request && request.enableNewURL) {
    if (process.env.REACT_APP_PROJECT_STAGE === "prod") {
      return CCP_NEW_URLS.PROD;
    } else {
      return CCP_NEW_URLS.DEV;
    }
  }
  return EndPointInfo.Connect;
};

// Testing
const capitalizeFirstLetter = (word) => {
  return word.charAt(0).toUpperCase() + word.slice(1);
};
// end
export const buildAttributeValue = (attribute, attributeValue) => {
  console.log("buildAttributeValue", attribute, attributeValue);
  let result = "NA";
  if (Array.isArray(attribute.key)) {
    // debugger;
    _.forEach(attribute.key, (value) => {
      let index = _.findIndex(attributeValue, { name: value });
      if (index > 0) {
        // original
        // result = attributeValue[index].value;
        // return false;
        // end

        // Testing
        if (attribute.UiName == "Product") {
          result = capitalizeFirstLetter(attributeValue[index].value);
          return false;
        } else {
          result = attributeValue[index].value;
          return false;
        }
        // end
      }
    });
  } else {
    let index = _.findIndex(attributeValue, { name: attribute.key });
    if (index > 0) {
      result = attributeValue[index].value;
    }
  }

  if (result == "NA" && "default" in attribute) {
    result = attribute.default;
  }

  // debugger;
  if (
    "displayValue" in attribute &&
    attribute.displayValue != undefined &&
    attribute.displayValue[result.toLowerCase()] != undefined
  ) {
    result = attribute.displayValue[result.toLowerCase()];
  }
  // Logic to replace attribute value when it was true
  if ("switchValue" in attribute && attribute.UiName != undefined) {
    const matchingNames = attribute.UiName;
    const matchingCondition =
      matchingNames.includes(attribute.UiName) && result === "true";
    if (matchingCondition) {
      console.log("enteredIntoLoop", attributeValue);
      const attributeName = attribute.switchValue[0];
      const matchingItem = attributeValue.find(
        (item) => item.name === attributeName
      );
      const newValue = matchingItem
        ? matchingItem.value
        : capitalizeFirstLetter(result);
      return [newValue];
    } else if (matchingNames.includes(attribute.UiName) && result === "false") {
      const newValue = capitalizeFirstLetter(result);
      return [newValue];
    }
  }
  // END
  //Logic to merge
  if ("mergeKey" && "format" in attribute) {
    const { key, format } = attribute;
    let merge = "";
    for (let i = 0; i < key.length; i++) {
      const matchingItem = attributeValue.find((item) => item.name === key[i]);
      const mergeValue = matchingItem ? matchingItem.value : "";
      merge += mergeValue;
      if (i !== key.length - 1) {
        merge += format[i];
      }
    }
    return merge;
  }
  // END
  return result;
};

export const isAttributeKeyExist = (attribute, attributeValue) => {
  console.log("isAttributeKeyExist", attribute, attributeValue);
  let result = -1;
  if (Array.isArray(attribute.key)) {
    _.forEach(attribute.key, (value) => {
      let index = _.findIndex(attributeValue, { name: value });
      if (index > 0) {
        result = index;
        return false;
      }
    });
  } else {
    result = _.findIndex(attributeValue, { name: attribute.key });
  }

  if (result < 0 && "default" in attribute) {
    result = 0;
  }

  return result;
};

export const generateUniqueID = (str1, str2, prefix) => {
  const combinedStr = str1 + str2;

  let hash = '';
  for (let i = 0; i < combinedStr.length; i++) {
    const char = combinedStr.charCodeAt(i);
    hash = `${hash}${combinedStr[i]}${char}`;
  }

  let hexString = hash.toString(16);

  while (hexString.length < 20) {
    hexString += "0"; // Pad with zeros if necessary
  }

  let idWithDashes = "";
  for (let i = 0; i < hexString.length; i += 3) {
    idWithDashes += hexString.substr(i, 4) + "-";
  }

  const uniqueID = prefix + "-" + idWithDashes.substring(0, 19);

  return uniqueID;
};

export const routingProfiles = {
  routingProfilesProd: ["MSO_RP_INTERNAL_SALES_1", "MSO_RP_INTERNAL_SALES_2", "MSO_RP_INTERNAL_SALES_3", "MSO_RP_INTERNAL_OB", "MSO_RP_INTERNAL_SALES_LICENSED"],
  routingProfilesDev: ["TransformHolding All", "Basic Routing Profile", "Basic Routing Profile - Chat"]
}

export const agentLdapCheck = {
  agentLdapCheckProd: ["rrajsan", "wsuresh", "vsinha", "kvardha", "ssurwas"],
  agentLdapCheckDev: []
}